import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';
const projects = [
  {
        title: 'Page Industries Limited',
        description: 'Co-founded the exclusive licensee for Jockey International in India in 1994, building it into a billion-dollar enterprise and one of India\'s most trusted apparel brands.',
        tags: ['Jockey India', 'Apparel', 'Brand Licensing'],
        gradient: 'var(--gradient-accent)',
        link: '#',
  },
  {
        title: 'Chummy Chum Foundation',
        description: 'Founded in 2007, a self-funded family initiative dedicated to bringing joy to underprivileged children in the Philippines and India through storytelling, music, and companionship.',
        tags: ['Philanthropy', 'Children\'s Welfare', 'Non-Profit'],
        gradient: 'var(--gradient-accent)',
        link: 'https://www.chummychum.org',
  },
  {
        title: 'Chummy Chum Songs & Characters',
        description: 'Created the beloved Chummy Chum character and original children\'s songs to bring smiles to kids during foundation visits to orphanages and children\'s homes.',
        tags: ['Music', 'Creativity', 'Children\'s Entertainment'],
        gradient: 'var(--gradient-accent)',
        link: '#',
  },
  {
        title: 'Sheraton Palawan',
        description: 'A 5-star luxury hotel currently under development on a 16-hectare Jewel Development zone in Palawan, Philippines. This flagship hospitality project brings world-class Sheraton standards to one of the most beautiful destinations in the world.',
        tags: ['Hospitality', '5-Star Hotel', 'Palawan'],
        gradient: 'var(--gradient-accent)',
        link: '#',
  },
  ];
function Projects() {
    return (
          <section className="projects section-padding" id="projects">
            <div className="container">
              <motion.div
            className="projects__header"
            initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">INITIATIVES & CREATIONS</span>
          <h2 className="section-title">
                      Key endeavors that<br />
                      <span className="text-gradient">define my journey</span>
          </h2>
          </motion.div>
<div className="projects__grid">
        {projects.map((project, index) => (
                      <motion.div
                                    className="projects__card"
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <h3 className="projects__card-title">{project.title}</h3>
              <p className="projects__card-description">{project.description}</p>
              <div className="projects__card-tags">
            {project.tags.map((tag, i) => (
                                <span className="projects__card-tag" key={i}>{tag}</span>
                ))}
                  </div>
                  </motion.div>
          ))}
            </div>
            </div>
            </section>
  );
}
export default Projects;
